import { GetResult } from "@/api/types";

export default function useGetResult(data: GetResult | undefined) {
  const totalRows = data?.total_rows;
  const totalCorrect = data?.total_correct || 0;
  const totalNotes = data?.total_notes || 0;
  const totalErrors = data?.total_errors || 0;
  const totalIgnored = data?.total_ignored || 0;
  const filters = data?.filters || {};
  const dataSource = data?.result || [];
  const uploadBlocked = data?.has_validation_issues || false;

  const hasErrors = totalErrors > 0;

  return {
    totalRows,
    totalCorrect,
    totalNotes,
    totalIgnored,
    filters,
    dataSource,
    totalErrors,
    hasErrors,
    uploadBlocked,
  };
}
